const routes = [
    {
        path: '/pre-analise-credito',
        name: 'pre-analise-credito',
        component: () =>
            import('@/modules/pre-analise-credito/views/PreAnaliseCredito.vue'),
        props: true,
        meta: {
            roles: ['ROLE_REGULAR']
        }
    }
];

export default routes;
